import useFetch from '@hooks/useFetch';
import { emptyList } from '@constants/empty';

const useStates = (countryCode = 'IN') => {
  const { data, ...rest } = useFetch(
    countryCode === 'IN'
      ? `v1/internationalization/states/?country_code=${countryCode}`
      : null
  );
  return { states: data ?? emptyList, ...rest };
};

export default useStates;
